import { maybe } from '@rematter/ui-web';

import { fullBookingFragment } from './fragmentsBooking';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { QueryAtomResult } from '~/shared/providers/api/createQueryAtomFactory';

export type FullBookingRecord = QueryAtomResult<typeof bookingDetailsQueryAtom>;

export const bookingDetailsQueryAtom = createQueryAtomFactory(
  'customerPortal.bookingDetails',
  (params: { id: string }) => ({
    bookings: {
      __args: {
        filter: {
          ids: [params.id],
        },
      },
      entries: {
        ...fullBookingFragment,
      },
    },
  }),
  {
    select: ({ bookings }) =>
      maybe(bookings.entries.at(0), (booking) => ({
        ...booking,
        // TODO: map actual purchase order
        purchaseOrderNumber: 'MCK-1234',
        // TODO: map actual supplier
        supplier: {
          id: '1',
          name: 'Mock Supplier Inc.',
        },
        files:
          booking.files?.map((file) => ({
            ...file,
            metadata: file.metadata as Record<string, unknown>,
          })) ?? [],
      })),
  },
);
